// extracted by mini-css-extract-plugin
export default {"AdminSuccessMsg":"styles_AdminSuccessMsg__wLPcJ","open":"styles_open__m1kZ5","icon":"styles_icon__9mDj5","success":"styles_success__+ymXp","error":"styles_error__4zleO"};